// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2ZGGQ","paramInput":"JobSimulator_paramInput__1jtdv","input":"JobSimulator_input__1hff4"};